import { withProps } from 'recompose'

const FormFieldContainer = definition => withProps(definition)

export default FormFieldContainer
